import React from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'

import CalendarDateCell from './CalendarDateCell'

import _ from 'lodash'
import renderHtml from 'react-render-html'

const CalendarDateCells = ({ currentDate, handleEventsPopup, selectedDate }) => {
  const eventsData = useSelector(state => state.eventsData)
  const activeCategory = useSelector(state => state.filtersData.category)

  let events = null

  if (eventsData && eventsData.data && !_.isEmpty(eventsData.data.events)) {
    if (activeCategory !== '') {
      let filteredEvents = []

      eventsData.data.events.forEach(event => {
        if (_.includes(event.categories, activeCategory)) {
          filteredEvents.push(event)
        }
      })

      events = filteredEvents
    } else {
      events = eventsData.data.events
    }
  }

  const monthStart = moment(currentDate).startOf('month')
  const monthEnd = moment(monthStart).endOf('month')
  const startDate = moment(monthStart).startOf('week')
  const endDate = moment(monthEnd).endOf('week')

  let weekRows = []
  let dayCells = []
  let day = startDate
  let eventTimeFormat = 'h:mma'

  if (process.env.REACT_APP_FORMAT_CALENDER_POPOVER_EVENT_TIME) {
    eventTimeFormat = process.env.REACT_APP_FORMAT_CALENDER_POPOVER_EVENT_TIME
  }

  while (day <= endDate) {
    for (let i = 0; i < 7; i++) {
      let renderCellEvents = []
      let renderPopoverEvents = []

      if (events) {
        for (let eventKey in events) {
          const currentEvent = events[eventKey]

          if (currentEvent && currentEvent.schedule) {
            for (const scheduleKey in currentEvent.schedule) {
              if (
                moment(day).isSame(currentEvent.schedule[scheduleKey].startDate, 'day') &&
                currentEvent.title
              ) {
                let eventTime = moment(currentEvent.schedule[scheduleKey].startDate).format(eventTimeFormat)

                if (currentEvent.isAllDay) {
                  eventTime = 'All Day'
                }

                renderCellEvents.push(
                  <div
                    key={'cell-event-' + currentEvent.id + '-' + day + '-' + eventTime}
                    className="u-calendar__date-event"
                  >
                    {currentEvent.marketingLink ? (
                      <a
                        href={currentEvent.marketingLink}
                        target={!currentEvent.isInternalLink ? '_blank' : '_self' }
                        rel="noopener noreferrer"
                        className="event-cta-link"
                      >
                        {renderHtml(currentEvent.title)}
                      </a>
                    ) : (
                      <p className="event-title u-remove-margin">
                        {renderHtml(currentEvent.title)}
                      </p>
                    )}
                  </div>
                )

                renderPopoverEvents.push(
                  <div
                    key={'cell-event-popover-' + currentEvent.id + '-' + day + '-' + eventTime}
                    className="flow-events-popover__entry"
                  >
                    {eventTime && <p className="event-time">{eventTime}</p>}

                    {currentEvent.marketingLink ? (
                      <a
                        href={currentEvent.marketingLink}
                        target={!currentEvent.isInternalLink ? '_blank' : '_self' }
                        rel="noopener noreferrer"
                        className="event-cta-link"
                      >
                        {renderHtml(currentEvent.title)}
                      </a>
                    ) : (
                      <p className="event-title u-remove-margin">
                        {renderHtml(currentEvent.title)}
                      </p>
                    )}
                  </div>
                )
              }
            }
          }
        }
      }

      dayCells.push(
        <CalendarDateCell
          key={day + 'event-cell'}
          currentDate={currentDate}
          day={day}
          handleEventsPopup={handleEventsPopup}
          renderCellEvents={renderCellEvents}
          renderPopoverEvents={renderPopoverEvents}
          selectedDate={selectedDate}
        />
      )

      day = moment(day).add(1, 'day')
    }

    weekRows.push(
      <div key={day} className="u-calendar__date-row">
        {dayCells}
      </div>
    )

    dayCells = []
  }

  return <div className="u-calendar__date-cells">{weekRows}</div>
}

export default CalendarDateCells
